import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';

export interface Props {
	className?: string;
	classes?: {
		root?: string;
		header?: string;
		content?: string;
	};
	width?: 'sm' | 'xl';
	icon: React.ReactNode;
	title: React.ReactNode;
	controls?: React.ReactNode;
}

const ExchangeRefundContentWrapper: React.FC<Props> = ({
	className,
	classes,
	width = 'xl',
	icon,
	title,
	controls,
	children
}) => {
	const { ExchangeRefundContentWrapper: theme } = useTheme('Entities').Order;

	return (
		<div
			className={cn(theme.root, className, classes?.root, {
				[theme.root_small]: width === 'sm'
			})}
		>
			<div className={cn(theme.header, classes?.header)}>
				<div className={theme.title}>
					<div className={theme.icon}>{icon}</div>

					{title}
				</div>
				{controls && <div className={theme.controls}>{controls}</div>}
			</div>

			{children}
		</div>
	);
};

export default ExchangeRefundContentWrapper;
